import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconIDCard: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00399 8.03337C5.12199 8.03337 4.40466 7.31535 4.40466 6.43335C4.40466 5.55135 5.12199 4.83333 6.00399 4.83333C6.88599 4.83333 7.604 5.55135 7.604 6.43335C7.604 7.31535 6.88599 8.03337 6.00399 8.03337ZM6.00399 5.83333C5.67332 5.83333 5.40466 6.10268 5.40466 6.43335C5.40466 6.76402 5.67332 7.03337 6.00399 7.03337C6.33465 7.03337 6.604 6.76402 6.604 6.43335C6.604 6.10268 6.33465 5.83333 6.00399 5.83333ZM8 11.1667C7.724 11.1667 7.5 10.9427 7.5 10.6667V10.4647C7.5 9.98468 7.16869 9.5 6.42802 9.5H5.57267C4.83201 9.5 4.50065 9.98468 4.50065 10.4647V10.6667C4.50065 10.9427 4.27665 11.1667 4.00065 11.1667C3.72465 11.1667 3.50065 10.9427 3.50065 10.6667V10.4647C3.50065 9.48868 4.21201 8.5 5.57267 8.5H6.42802C7.78869 8.5 8.5 9.48801 8.5 10.4647V10.6667C8.5 10.9427 8.276 11.1667 8 11.1667ZM12 13.5H4C2.388 13.5 1.5 12.612 1.5 11V5C1.5 3.388 2.388 2.5 4 2.5H12C13.612 2.5 14.5 3.388 14.5 5V11C14.5 12.612 13.612 13.5 12 13.5ZM4 3.5C2.94867 3.5 2.5 3.94867 2.5 5V11C2.5 12.0513 2.94867 12.5 4 12.5H12C13.0513 12.5 13.5 12.0513 13.5 11V5C13.5 3.94867 13.0513 3.5 12 3.5H4ZM12.5 6.62533C12.5 6.34933 12.276 6.12533 12 6.12533H9.33333C9.05733 6.12533 8.83333 6.34933 8.83333 6.62533C8.83333 6.90133 9.05733 7.12533 9.33333 7.12533H12C12.276 7.12533 12.5 6.90133 12.5 6.62533ZM12.4667 9.33333C12.4667 9.05733 12.2427 8.83333 11.9667 8.83333H9.96668C9.69068 8.83333 9.46668 9.05733 9.46668 9.33333C9.46668 9.60933 9.69068 9.83333 9.96668 9.83333H11.9667C12.2427 9.83333 12.4667 9.60933 12.4667 9.33333Z"
      fill={color}
    />
  </svg>
);

export default IconIDCard;
